import { Button, ButtonProps, styled } from '@mui/material';

// Create a styled button that matches the "Mehr erfahren" button on Lansco.de
const StyledButton = styled(Button)<ButtonProps>(({ theme }) => ({
  display: 'inline-block',
  padding: '8px 25px',
  border: `1px solid ${theme.palette.primary.main}`,
  borderRadius: '3px',
  backgroundColor: theme.palette.primary.main,
  color: '#fff',
  fontFamily: '"Open Sans", "Rubik", "Helvetica Neue", sans-serif',
  fontSize: '14px',
  fontWeight: 400,
  lineHeight: '28px',
  textTransform: 'none',
  textDecoration: 'none',
  transition: 'all 0.3s ease',
  position: 'relative',
  overflow: 'hidden',
  '&:hover': {
    backgroundColor: '#c21718',
    textDecoration: 'none',
    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.15)',
  },
  '&:before': {
    content: '""',
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    height: '2px',
    background: 'linear-gradient(to right, #c21718, #c21718)',
  },
  '&.white': {
    backgroundColor: '#fff',
    color: '#c21718',
    '&:hover': {
      backgroundColor: '#f8f8f8',
      boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
    },
  },
  '&:disabled': {
    backgroundColor: '#fff',
    color: '#999',
    border: '1px solid #ddd',
    boxShadow: 'none',
    '&:before': {
      background: 'linear-gradient(to right, #ddd, #eee)',
    },
  },
}));

// Component to use the styled button
type LanscoButtonProps = Omit<ButtonProps, 'variant'> & { 
  variant?: 'default' | 'white';
};

export const LanscoButton = (props: LanscoButtonProps) => {
  const { variant = 'default', children, ...rest } = props;
  const className = variant === 'white' ? 'white' : '';
  
  return (
    <StyledButton className={className} {...rest}>
      {children}
    </StyledButton>
  );
};

// Keep the default export for backward compatibility
export default LanscoButton;